import React, { useState } from 'react'

import { login } from '../util/session'

const LoginForm = (props) => {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [error, setError] = useState('')

    const handleSubmit = (e) => {
        e.preventDefault()
        login({email, password}).then(res => {
            props.history.push('/admin/report')
        }).catch(err => setError('Invalid credentials'))
        setTimeout(() => setError(''), 3000)
    }
    
    // return (
    //     <div>
    //         <form onSubmit={(e) => handleSubmit(e)}>
    //             <input type='text' value={email} onChange={(e) => setEmail(e.target.value)}/>
    //             <input type='text' value={password} onChange={(e) => setPassword(e.target.value)}/>
    //             <button type='submit'>submit</button>
    //         </form>
    //     </div>
    // )

    return (
        <form style={{marginLeft: "20%", marginRight: "20%", marginTop: "100px"}} onSubmit={(e) => handleSubmit(e)}>
            <h3>Log in</h3>

            <div className="form-group">
                <label>Email</label>
                <input type="email" className="form-control" placeholder="Enter email" value={email} onChange={(e) => setEmail(e.target.value)}/>
            </div>

            <div className="form-group">
                <label>Password</label>
                <input type="password" className="form-control" placeholder="Enter password" value={password} onChange={(e) => setPassword(e.target.value)}/>
            </div>
            <button type="submit" className="btn btn-dark btn-lg btn-block">Log in</button>
            {error === '' ? null : <div className="alert alert-danger" role="alert" style={{marginTop: "10px"}}>
                {error}
            </div>
            }
        </form>
    );
}

export default LoginForm